module.exports = __webpack_public_path__ + "static/media/slide3.0f6ee3f9.svg";